/*
 * SmartHome-Energy — Meterware im Warenkorb (Header-Drawer + Warenkorbseite)
 * ---------------------------------------------------------------------------
 * v1 · 28.09.2026
 *
 * Meterware wird über Cent-Einheiten abgerechnet: Variantenpreis 0,01 €,
 * quantity = Gesamtpreis in Cent (z. B. 13 × 5.040 mm à 9,30 €/lfm →
 * quantity 60931). Die echte Bestellung steckt in den Properties
 *   _lfm_mm  (Länge je Stück in mm)
 *   _lfm_stk (Stückzahl)
 * die der Laufmeter-Konfigurator setzt.
 *
 * Dieses Skript sorgt dafür, dass der Kunde nie die Cent-Menge sieht:
 *
 * 1. Header-Drawer (sections/she-header.liquid, div[data-shx-cart])
 *    Der Drawer rendert seine Positionen per JS aus /cart.js. Wir beobachten
 *    [data-shx-cart-body] und ersetzen bei Meterware-Zeilen den Mengen-
 *    Stepper durch „13 Stück × 5.040 mm“, Gesamtlänge, Stückpreis und einen
 *    Stepper, der die STÜCKZAHL ändert (quantity wird mitgerechnet).
 *    Der ursprüngliche ± Stepper hätte die Cent-Menge um 1 verändert und
 *    damit Preis und Properties auseinanderlaufen lassen.
 *
 * 2. Warenkorb-Symbol: zählt Meterware nach Stück (nicht 60.931 Artikel).
 *
 * 3. Warenkorbseite (snippets/cart-items.liquid): Stepper [data-she-lfmq]
 *    ändert die Stückzahl und lädt die Seite neu.
 *
 * Global geladen über snippets/doc-head-core.liquid; selbst-guardend.
 */
(function () {
  'use strict';
  if (window.__sheLfmCart) return;
  window.__sheLfmCart = true;

  var fInt = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  var fDec2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: cur }); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }

  function lfmOf(it) {
    var p = it && it.properties;
    if (!p || !p._lfm_mm) return null;
    var mm = parseInt(p._lfm_mm, 10);
    var stk = parseInt(p._lfm_stk, 10) || 1;
    if (!mm) return null;
    var upp = Math.max(1, Math.round(it.quantity / stk)); // Cent-Einheiten je Stück
    // „€ 9,30 / lfm“ → 930 Cent, damit alle Beträge im Drawer gleich formatiert sind
    var lfmCents = NaN, raw = String(p['Laufmeterpreis'] || '').replace(/[^0-9,.]/g, '');
    if (raw) lfmCents = Math.round(parseFloat(raw.replace(/\./g, '').replace(',', '.')) * 100);
    return { mm: mm, stk: stk, upp: upp, piece: Math.round(it.final_line_price / stk), lfm: isNaN(lfmCents) ? '' : money(lfmCents) + ' / lfm' };
  }
  function countItems(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { var l = lfmOf(it); n += l ? l.stk : it.quantity; });
    return n;
  }
  function newProps(old, mm, stk) {
    var o = {};
    o['Länge'] = fInt.format(mm) + ' mm';
    o['Stückzahl'] = String(stk);
    o['Gesamtlänge'] = fDec2.format((mm * stk) / 1000) + ' lfm';
    Object.keys(old || {}).forEach(function (k) { if (!(k in o) && k !== '_lfm_stk') o[k] = old[k]; });
    o._lfm_stk = String(stk);
    return o;
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  /* Stückzahl einer Meterware-Position ändern; stk < 1 entfernt die Position */
  function setPieces(key, dir) {
    return getCart().then(function (cart) {
      var it = (cart.items || []).filter(function (x) { return x.key === key; })[0];
      var l = lfmOf(it);
      if (!l) throw new Error('Position nicht gefunden');
      var next = l.stk + dir;
      if (next > 999) throw new Error('max');
      var body = next < 1
        ? { id: key, quantity: 0 }
        : { id: key, quantity: l.upp * next, properties: newProps(it.properties, l.mm, next) };
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    });
  }

  /* ---------- CSS ---------- */
  var css =
    '.shx-cartd__body .shx-ci:not([data-she-ok]) .shx-ci__qty{visibility:hidden}' +
    '.shx-ci__cut{margin-top:6px;font-size:13.5px;font-weight:700;color:#111;line-height:1.35}' +
    '.shx-ci__meta{font-size:11.5px;color:#5b616b;line-height:1.45;margin-top:1px}' +
    '.shx-ci__tag{display:inline-block;margin-top:5px;font-size:10.5px;font-weight:700;letter-spacing:.02em;color:#b34700;' +
    'background:#fff4ec;border:1px solid rgba(255,102,0,.28);border-radius:20px;padding:1px 8px}' +
    '.shx-ci__lfmrow{display:block}' +
    '.shx-ci__qty--lfm span{min-width:48px;text-align:center;white-space:nowrap;font-size:13px;font-weight:600}' +
    '.shx-ci.is-busy,.she-lfmq.is-busy{opacity:.5;pointer-events:none}';
  var st = document.createElement('style');
  st.id = 'she-lfm-cart-css';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12h14"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M12 5v14M5 12h14"/></svg>';

  /* ---------- Header-Drawer ---------- */
  /* Der Header schreibt bei jedem Rendern cart.item_count (= Cent-Summe) ins
     Symbol. Ein Observer ersetzt diesen Rohwert sofort durch die Stückzahl,
     damit keine „91101“ aufblitzt. doc-head-core blendet das Symbol aus, bis
     data-she-n gesetzt ist (nur wenn Meterware im Warenkorb liegt). */
  var rawCache = null, nCache = null, badgeObs = null;
  function fixBadge(el) {
    if (nCache === null) return;
    if (el.textContent === String(rawCache) && rawCache !== nCache) el.textContent = nCache;
    el.classList.toggle('is-empty', nCache === 0);
    el.setAttribute('data-she-n', '1');
  }
  function setCounts(cart) {
    nCache = countItems(cart);
    rawCache = cart.item_count;
    var els = document.querySelectorAll('[data-shx-cart-count]');
    if (!badgeObs && window.MutationObserver) {
      badgeObs = new MutationObserver(function (recs) {
        recs.forEach(function (r) {
          var el = r.target.nodeType === 1 ? r.target : r.target.parentNode;
          if (el && el.matches && el.matches('[data-shx-cart-count]')) fixBadge(el);
        });
      });
      els.forEach(function (el) { badgeObs.observe(el, { childList: true, characterData: true, subtree: true }); });
    }
    els.forEach(function (el) { el.textContent = nCache; fixBadge(el); });
  }

  function decorate(cart) {
    var body = document.querySelector('[data-shx-cart-body]');
    setCounts(cart);
    if (!body) return;
    var byKey = {};
    (cart.items || []).forEach(function (it) { byKey[it.key] = it; });
    body.querySelectorAll('.shx-ci').forEach(function (row) {
      if (row.hasAttribute('data-she-ok')) return;
      var it = byKey[row.getAttribute('data-key')];
      var l = lfmOf(it);
      if (l) {
        var qty = row.querySelector('.shx-ci__qty');
        var box = document.createElement('div');
        box.className = 'shx-ci__lfmrow';
        box.innerHTML =
          '<div class="shx-ci__cut">' + l.stk + ' Stück × ' + fInt.format(l.mm) + ' mm</div>' +
          '<div class="shx-ci__meta">' + fDec2.format((l.mm * l.stk) / 1000) + ' lfm gesamt · ' +
          money(l.piece) + ' / Stück' + (l.lfm ? ' · ' + esc(l.lfm) : '') + '</div>' +
          '<span class="shx-ci__tag">Maßanfertigung</span>' +
          '<div><div class="shx-ci__qty shx-ci__qty--lfm">' +
          '<button type="button" data-she-lfm-dir="-1" aria-label="Ein Stück weniger">' + MINUS + '</button>' +
          '<span>' + l.stk + ' Stk.</span>' +
          '<button type="button" data-she-lfm-dir="1" aria-label="Ein Stück mehr">' + PLUS + '</button>' +
          '</div></div>';
        if (qty) qty.parentNode.replaceChild(box, qty);
        row.setAttribute('data-lfm', '1');
      }
      row.setAttribute('data-she-ok', '1');
    });
  }

  var busy = false, again = false;
  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(decorate).catch(function () {
      var b = document.querySelector('[data-shx-cart-body]');
      if (b) b.querySelectorAll('.shx-ci').forEach(function (r) { r.setAttribute('data-she-ok', '1'); });
    }).then(function () {
      busy = false;
      if (again) { again = false; refresh(); }
    });
  }

  /* Header-Drawer neu laden lassen: der Header öffnet + lädt beim Klick aufs Warenkorb-Symbol */
  function reloadHeaderDrawer() {
    var icon = document.querySelector('[data-shx-open-cart]');
    if (icon) icon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, button: 0 }));
    else refresh();
  }

  function init() {
    var body = document.querySelector('[data-shx-cart-body]');
    if (body && window.MutationObserver) {
      new MutationObserver(function () { refresh(); }).observe(body, { childList: true });
    }
    refresh();

    /* Stepper im Drawer — Capture-Phase, damit der Header-Handler nicht mitläuft */
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-she-lfm-dir]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var row = btn.closest('.shx-ci');
      if (!row || row.classList.contains('is-busy')) return;
      row.classList.add('is-busy');
      setPieces(row.getAttribute('data-key'), parseInt(btn.getAttribute('data-she-lfm-dir'), 10) || 0)
        .then(function () {
          // Auf der Warenkorbseite (form#cart) neu laden; der versteckte Alt-Drawer
          // <cart-drawer> enthält ebenfalls [data-she-lfmq] und zählt nicht.
          if (document.querySelector('form#cart [data-she-lfmq]')) window.location.reload();
          else reloadHeaderDrawer();
        })
        .catch(function () { row.classList.remove('is-busy'); });
    }, true);

    /* Stepper auf der Warenkorbseite */
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-she-lfmq-dir]') : null;
      if (!btn) return;
      e.preventDefault();
      var box = btn.closest('[data-she-lfmq]');
      if (!box || box.classList.contains('is-busy')) return;
      box.classList.add('is-busy');
      var inDrawer = !!box.closest('cart-drawer');
      setPieces(box.getAttribute('data-key'), parseInt(btn.getAttribute('data-she-lfmq-dir'), 10) || 0)
        .then(function () {
          // Warenkorbseite: neu laden. Theme-Drawer <cart-drawer>: per Event neu rendern lassen.
          if (!inDrawer) return window.location.reload();
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          refresh();
        })
        .catch(function () { box.classList.remove('is-busy'); });
    });

    /* Nach „In den Warenkorb“ im Konfigurator: Header-Drawer öffnen */
    document.addEventListener('she:cart:added', reloadHeaderDrawer);
    /* Konfigurator öffnet den Theme-Drawer <cart-drawer>: Symbol + Header-Drawer nachziehen */
    ['on:cart:add', 'dispatch:cart-drawer:refresh'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(refresh, 150); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.SHE_lfm = { lfmOf: lfmOf, countItems: countItems };
})();
